import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import lists from './lists';
import stats from './stats';
import create from './create';

const GiftCards = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
      <Route path={`${match.url}/list`} component={lists}/>
      <Route path={`${match.url}/create`} component={create}/>
      <Route path={`${match.url}/:id`} component={stats}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default GiftCards;
